import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const TaxMaster = () => {
  const [editMode, setEditMode] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [taxList, setTaxList] = useState([]);
  const [taxid, settaxid] = useState('');
  const [taxName, setTaxName] = useState('');
  const [taxValue, setTaxValue] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});


  useEffect(() => {
    fetchTaxMasterData();
}, [currentPage]);

const fetchTaxMasterData = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/tax-master/get`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setTaxList(response.data);
      
      setIsLogin(false);
  } catch (error) {
    setTaxList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};


const validateForm = () => {
  const newErrors = {};

  if (!taxName) newErrors.taxName = 'Tax Name is required';
  if (!taxValue) newErrors.taxValue = 'Tax Value is required';
  if (!description) newErrors.description = 'Description is required';

  return newErrors;
};


const createTaxMaster = async () => {
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object instead of FormData
    const payload = {
      tax_name: taxName,
      tax_value: taxValue,
      description: description
    };
  
    try {
      const response = await axios.post(`${var_api}/api/tax-master/post`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Tax Created Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Tax created successfully!');
      }
      fetchTaxMasterData();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const updateTaxMaster = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    
    const newErrors = validateForm();
    setErrors(newErrors); // Update the state with validation errors
  
    // If there are errors, don't proceed with the form submission
    if (Object.keys(newErrors).length > 0) {
      return;
    }
  
    // Create a JSON object instead of FormData
    const payload = {
      tax_name: taxName,
      tax_value: taxValue,
      description: description
    };
  
    try {
      const response = await axios.put(`${var_api}/api/tax-master/put/${taxid}`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Tax Updated Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Tax updated successfully!');
      }
      fetchTaxMasterData();
      resetForm();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };
  

  const handleStatusChange = async (tax, newStatus) => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
  
    // Create a JSON object with only the is_active field
    const payload = {
      is_active: newStatus
    };
  
    try {
      const response = await axios.put(`${var_api}/api/tax-master/put/${tax.id}`, payload, {
        headers: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Tax Updated Successfully',
          confirmButtonColor: '#007500',
        });
        console.log('Tax updated successfully!');
      }
      fetchTaxMasterData();
    } catch (error) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    } finally {
      setIsLogin(false);
    }
  };  


  const resetForm = () => {
    setTaxName('');
    setTaxValue('');
    setDescription('');
    setEditMode(false); // Assuming you set profile file
};


const handleEdit = (tax) => {
    setEditMode(true);
    settaxid(tax.id);
    setTaxName(tax.tax_name);
    setTaxValue(tax.tax_value);
    setDescription(tax.description);
  };

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter tax before applying pagination
  const filteredEmployees = Array.isArray(taxList) && taxList.filter(tax => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (tax.tax_name && tax.tax_name.toString().toLowerCase().includes(searchLower)) ||
      (tax.tax_value && tax.tax_value.toString().toLowerCase().includes(searchLower)) ||
      (tax.description && tax.description.toString().toLowerCase().includes(searchLower))
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       TAX MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Tax' : 'Create Tax'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Group controlId="formBasicName" className="mt-3">
                        <Form.Label>Tax Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Tax Name"
                            name="taxName"
                            value={taxName}
                            onChange={(e) =>  setTaxName(e.target.value)}
                            required
                        />
                         {errors.taxName && <p style={{ color: 'red' }}>{errors.taxName}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="mt-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Description"
                            name="description"
                            value={description}
                            onChange={(e) =>  setDescription(e.target.value)}
                            required
                        />
                        {errors.description && <p style={{ color: 'red' }}>{errors.description}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicPhone" className="mt-3">
                        <Form.Label>Tax Value(%)</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter tax value"
                            name="taxvalue"
                            value={taxValue}
                            onChange={(e) =>  setTaxValue(e.target.value)}
                            required
                        />
                        {errors.taxValue && <p style={{ color: 'red' }}>{errors.taxValue}</p>}
                    </Form.Group>
                     <Button variant="primary" type="button" className="mt-3" 
                      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                      onClick={createTaxMaster} hidden={editMode}  // This will hide the Submit button when editMode is true
                        >
                    Submit
                    </Button>{" "}
                    <Button variant="primary" type="button" className="mt-3"
                     style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
                     onClick={() => updateTaxMaster()} hidden={!editMode}  // This will hide the Update button when editMode is false
                    >
                    Update
                    </Button>{" "}

                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Tax List  <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  

        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Tax Name</th>
              <th>Tax Value(%)</th>
              <th>Description</th>
              <th>Status</th>
              <th>Action</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((tax, index) => (
      <tr key={tax.id}>
        <td>{startIndex + index + 1}</td>
        <td>{tax.tax_name}</td>
        <td>{tax.tax_value}</td>
        <td>{tax.description}</td>
        <td>
          <Form.Check
            type="switch"
            id={`custom-switch-${tax.id}`}
            label=""
            checked={tax.is_active === 1}
            onChange={(e) => handleStatusChange(tax, e.target.checked ? 1 : 0)}
          />
        </td>
        <td>
          <Button variant="primary" className="m-1" onClick={() => handleEdit(tax)}>
            <i className="bi bi-pencil-square"></i>
          </Button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default TaxMaster;